import React from 'react';

const PostActionItem = ({
  disabled = false,
  icon,
  height = 24,
  customClass,
  iconClass,
  iconStyle,
  onClick,
  children,
  fill,
}) => {
  let IconComponent = typeof icon === 'function' ? icon : null;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <div
      onClick={e => (disabled ? e.preventDefault() : handleClick())}
      className={`  ${customClass} ${disabled ? '' : 'cursor-pointer'}`}
    >
      <IconComponent height={height} className={iconClass} style={iconStyle} fill={fill} />
      {children}
    </div>
  );
};

export default PostActionItem;
